import { scrollTo } from 'modules/ScrollTo'

const getNavHeight = () => {
  return $('header').outerHeight(true)
}

const setScroll = () => {
  const element = '.navigation-link',
    options = {
      ease: Power4.easeInOut,
      onResize: true
    }
  _.each($(element), (element, index) => {
    scrollTo(element, element.hash, getNavHeight(), options)
  })
}

$(window).on('resize load', _.debounce(setScroll, 500))
